import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
  useRef,
} from "react";
import { Button, Col, Row, Spinner, Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  DatatableWrapper,
  Filter,
  Pagination,
  PaginationOptions,
  TableBody,
  TableHeader,
} from "react-bs-datatable";
import moment from "moment";
// import { useNavigate } from "react-router-dom";
// import { useLocation } from "react-router-dom";
import Confirm from "../Confirm";
import TaskEdit from "./TaskEdit";
import TaskView from "./TaskView";
import Permissionhelper from "../common/Permissionhelper";
import * as constants from "../../constants/CONSTANT";
import solisPowerApi from "../../api/solisPowerApi";
import { formatDate, formatDateForView, getUserDetails } from "../../utils/helper";
import PERMISSIONS from "../../constants/permissions";

const RelatedListTask = ({ parent, refreshTaskList, table }) => {
  const userInfo = getUserDetails();
  const [modalShow, setModalShow] = React.useState(false);
  const [task, setTask] = React.useState("");
  const [modalShowTask, setModalShowTask] = React.useState(false);
  const [modalShowTaskView, setModalShowTaskView] = React.useState(false);
  const [isFollowUp, setModalShowFollowUp] = React.useState(false);


  // Create table headers consisting of 4 columns.

  const [body, setBody] = useState([]);
  useEffect(() => {
    console.log(parent);
    taskList();

    if (table === 'Lead') {
      setModalShowFollowUp(true);
    }
  }, []);

  useEffect(() => {
    taskList();
  }, [refreshTaskList]);

  const taskList = () => {
    async function init() {
      let tasks = await solisPowerApi.fetchTasksByParentId(parent.id);

      //console.log(tasks);
      if (tasks && tasks?.length > 0) {
        setBody(tasks);
      } else {
        setBody([]);
      }
    }
    init();
  };
  const handleDelete = (row) => {
    setModalShow(true);
    setTask(row);
  };

  const labels = {
    beforeSelect: " ",
  };

  const deleteTask = async () => {
    ////console.log('task.id',task.id)
    const result = await solisPowerApi.deleteTaskById(task.id);
    ////console.log('result',result)
    if (result.success) {
      setTask("");
      setModalShow(false);
      taskList();
    }
  };

  const submitTasks = () => {
    setModalShowTask(false);
    taskList();
  };

  const handleSaveAndCreateNext = () => {
    setModalShowTask(false);
    taskList();
    setTask(undefined);
    setTimeout(() => {
      setModalShowTask(true);
    }, 0);
  };

  const editTask = (row) => {
    setModalShowTask(true);
    setTask(row);
  };

  const viewTask = (row) => {
    setModalShowTaskView(true);
    setTask(row);
  };

  const Taskheader = [
    {
      title: "Title",
      prop: "title",
      cell: (row) => (
        <Link onClick={() => viewTask({ row })} state={parent}>
          {row.title}
        </Link>
      ),
    },
    { title: "Type", prop: "type" },
    { title: "Assigned", prop: "owner_name" },

    { title: "Status", prop: "status" },
    { title: "Priority", prop: "priority" },
    //formatDateForView added by shahir hussain 27-08-2025
    {
      title: "Target Date",
      prop: "targetdate",
      cell: (row) => formatDateForView(row.targetdate),
    },
    {
      title: "Created Date",
      prop: "createddate",
      cell: (row) => formatDateForView(row.createddate),
    },
    {
      title: "Actions",
      prop: "id",
      cell: (row) => (
        <>
          {[PERMISSIONS.MODIFY_ALL, PERMISSIONS?.MODIFY_TASK].some(permission => {
            return userInfo?.permissions?.map(p => p.name).includes(permission);
          }) && (
              <Button className="btn-sm mx-2" onClick={() => editTask({ row })}>
                <i className="fa-regular fa-pen-to-square"></i>
              </Button>
            )
          }
          {[PERMISSIONS.DELETE_ALL, PERMISSIONS?.DELETE_TASK].some(permission => {
            return userInfo?.permissions?.map(p => p.name).includes(permission);
          }) && (
              <Button
                className="btn-sm mx-2"
                variant="danger"
                onClick={() => handleDelete(row)}
              >
                <i className="fa-regular fa-trash-can"></i>
              </Button>
            )
          }
        </>
      ),
    },
  ];

  const FollowUpheader = [
    {
      title: "Follow Up Title",
      prop: "title",
      cell: (row) => (
        <Link onClick={() => viewTask({ row })} state={parent}>
          {row.title}
        </Link>
      ),
    },
    { title: "Type", prop: "type" },
    { title: "Assigned", prop: "owner_name" },

    { title: "Status", prop: "status" },
    { title: "Priority", prop: "priority" },

    {
      title: "Target Date",
      prop: "targetdate",
      cell: (row) =>
        row?.targetdate
          ? new Date(row.targetdate).toLocaleString("en-IN", {
            timeZone: "Asia/Kolkata",
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          })
          : "",
    },
    {
      title: "Created Date",
      prop: "createddate",
      cell: (row) => moment(row.createddate).format("DD-MM-YYYY"),
    },
    {
      title: "Actions",
      prop: "id",
      cell: (row) => (
        <>
          <Button className="btn-sm mx-2" onClick={() => editTask({ row })}>
            <i className="fa-regular fa-pen-to-square"></i>
          </Button>
          {Permissionhelper.checkPermission(constants.SUPER_ADMIN) && (
            <Button
              className="btn-sm mx-2"
              variant="danger"
              onClick={() => handleDelete(row)}
            >
              <i className="fa-regular fa-trash-can"></i>
            </Button>
          )}
        </>
      ),
    },
  ];

  const headers = isFollowUp ? FollowUpheader : Taskheader

  return (
    <>
      {modalShow && (
        <Confirm
          show={modalShow}
          onHide={() => setModalShow(false)}
          deleteTask={deleteTask}
          title="Confirm delete?"
          message="You are going to delete the record. Are you sure?"
          table="task"
        />
      )}
      {modalShowTask && (
        <TaskEdit
          show={modalShowTask}
          onHide={() => setModalShowTask(false)}
          parentid={parent.id}
          task={task}
          table={table}
          submitTasks={submitTasks}
          onSaveAndCreateNext={handleSaveAndCreateNext}
        />
      )}

      {modalShowTaskView && (
        <TaskView
          show={modalShowTaskView}
          onHide={() => setModalShowTaskView(false)}
          parentid={parent.id}
          task={task}
          table={table}
          submitTasks={submitTasks}
        />
      )}

      {body ? (
        <DatatableWrapper
          body={body}
          headers={headers}
          paginationOptionsProps={{
            initialState: {
              rowsPerPage: 5,
            },
          }}
        >
          <Row className="mb-4">
            <Col
              xs={12}
              sm={6}
              lg={4}
              className="d-flex flex-col justify-content-start align-items-start"
            ></Col>
            <Col
              xs={12}
              sm={6}
              lg={4}
              className="d-flex flex-col justify-content-start align-items-start"
            ></Col>
            <Col
              xs={12}
              sm={6}
              lg={4}
              className="d-flex flex-col justify-content-end align-items-end"
            ></Col>
          </Row>
          <Table striped className="related-list-table shadow rounded sm " responsive={true}>
            <TableHeader classes={{ th: 'bg-custom text-white' }} />
            {
              (body && Array.isArray(body)) ?
                <TableBody />
                :
                <tbody className="">
                  <tr>
                    <td colSpan={100} align="center">
                      <div>
                        <Spinner />
                      </div>
                    </td>
                  </tr>
                </tbody>
            }
          </Table>
          <Pagination classes={{ buttonGroup: "btn-custom", button: "bg-custom border-white" }} />
        </DatatableWrapper>
      ) : (
        ""
      )}
    </>
  );
};

export default RelatedListTask;
